import { UserPermission } from '@/models/enums/permissions'
import { IUserDTO } from '@/models/user'

function parseStoredUser(): IUserDTO | null {
  const storedUser = localStorage.getItem('user')
  if (!storedUser) return null
  const userData = JSON.parse(storedUser)
  return new IUserDTO(
    userData.description,
    userData.name,
    userData.email,
    '',
    userData.clientType,
    userData.userType,
    userData.blocked,
    new Date(userData.updatedAt),
    userData.receiveEmails,
  )
}

export const hasPermission = (permission: UserPermission) => {
  return parseStoredUser()?.permissions.includes(permission) ?? false
}
